import Button from 'components/Button'
import ListRow from 'components/ListRow'
import TextBody from 'components/TextBody'
import { STYLES_COLOR, STYLES_FONT_WEIGHT } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

class MenuOption extends React.Component {
  static COLOR = STYLES_COLOR

  static defaultProps = {
    color: STYLES_COLOR.BLACK_LIGHT
  }

  static propTypes = {
    children: PropTypes.element,
    label: PropTypes.string,
    color: PropTypes.string,
    isStandalone: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  }

  render () {
    let element
    if (this.props.label) {
      element = (
        <ListRow
          hasHover
          isBorderless
          justify={this.props.isStandalone ? ListRow.JUSTIFY.CENTER : undefined}
        >
          <TextBody
            style={{
              color: this.props.color,
              fontWeight: this.props.isBold
                ? STYLES_FONT_WEIGHT.BOLD_MEDIUM
                : undefined
            }}
          >
            {this.props.label}
          </TextBody>
        </ListRow>
      )
    } else {
      element = this.props.children
    }
    return (
      <Button
        d='block'
        style={{
          width: '100%',
          backgroundColor: '#ffffff',
          zIndex: '420',
          cursor: 'pointer',
          padding: 0
        }}
        onClick={this.props.onClick}
        {...(this.props.buttonProps || {})}
      >
        {element}
      </Button>
    )
  }
}

export default MenuOption
